import { useNavigate, useSearchParams } from "react-router-dom";
import { getAppIdByCertificateNumber } from "../../../../../axios/api/services";
import { CircularLoader, Page404, useAsyncCall } from "@duosoftbg/nacid-components";
import React, { useEffect, useState } from "react";

const CertificateView = () => {
  const navigate = useNavigate();
  const { asyncCall } = useAsyncCall();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [searchParams] = useSearchParams();
  let appType = searchParams.get("at");
  let certificateUuid = searchParams.get("q");

  useEffect(() => {
    if (!appType || !certificateUuid || !(appType === "AR" || appType === "RP" || appType === "SE")) {
      setLoading(false);
      setNotFound(true);
    } else if (appType === "SE") {
      setLoading(false);
      setNotFound(false);
      navigate(`secondary-recognition/qrcode/view?qrCodeUUID=${certificateUuid}`);
    } else {
      asyncCall({
        processResponseErrors: false,
        promise: getAppIdByCertificateNumber(appType, certificateUuid),
        onSuccess: (id) => {
          if (appType === "RP") {
            navigate(`/professional-qualifications/view?id=${id}`);
          }

          if (appType === "AR") {
            navigate(`/academic-recognitions/view?id=${id}&type=NACID`);
          }
        },
        onError: () => {
          setLoading(false);
          setNotFound(true);
        },
      });
    }

    return () => {
      setLoading(true);
      setNotFound(false);
    };
  }, [appType, certificateUuid]);

  if (loading) {
    return <CircularLoader mt={3} />;
  }

  if (notFound) {
    return <Page404 />;
  }

  return <Page404 />;
};

export default CertificateView;
